import { useQuery } from '@tanstack/react-query';

import { sessionsService } from '../services/sessionsService';
import type { SessionMetricsParams, SessionMetricsResponse } from '../types';

import { sessionsKeys } from './useSessions';

/**
 * Aggregate counts for the metrics row above the admin session list. Keyed on
 * the full filter object so a filter change busts the cache and refetches in
 * parallel with the list query. Disable with `enabled` while params are still
 * being assembled (not currently needed — admin screens always have a filter
 * object, even if empty).
 */
export function useSessionMetrics({ filters }: { filters: SessionMetricsParams }) {
  return useQuery<SessionMetricsResponse>({
    queryKey: sessionsKeys.operation('metrics', filters),
    queryFn: () => sessionsService.getMetrics(filters),
  });
}
